<rt-box
  [class.active]="rewardsVisible && application.referralReward"
  (click)="selectCandidate(application)"
  class="grid-container"
  variant="no-padding no-radius"
  padding-small
>
  <div class="referral">
    <rt-avatar
      [type]="application.photoThumbUrl ? 'image' : application.name ? 'initials' : 'icon'"
      [shape]="'oval'"
      [size]="'base'"
      [imageSrc]="application.photoThumbUrl"
      [fullName]="application.name"
      [iconName]="$any(!application.name && 'person')"
      [class.completed]="
        showStatus && application.referralStatus === ReferralStatus.ProcessComplete
      "
      [class.success]="showStatus && application.referralStatus === ReferralStatus.Claimed"
      margin-right-small
    ></rt-avatar>
    <div layout-vertical>
      <rt-heading *ngIf="application.name; else deletedCantidate" variant="heading">
        {{ application.name }}
      </rt-heading>
      <ng-template #deletedCantidate>
        <span *ngIf="!application.name" text-bold>
          {{ 'rtr.profile.applications.removed_candidate' | translate }}
        </span>
      </ng-template>
      <div layout layout-wrap>
        <span *ngIf="type === ReferralContext.Referrals" margin-right-small>{{
          application.offerTitle
        }}</span>
        <div layout>
          <rt-icon
            [name]="
              showStatus && application.referralStatus
                ? statusTranslationsMap[application.referralStatus].icon
                : statusTranslationsMap[ReferralStatus.InReview].icon
            "
            margin-right-small-xx
          ></rt-icon>
          <span>
            {{
              showStatus && application.referralStatus
                ? statusTranslationsMap[application.referralStatus].status
                : statusTranslationsMap[ReferralStatus.InReview].status
            }}
            {{ (showStatus ? application.updatedAt : application.createdAt) | rtTimeAgo }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="application.referralReward && rewardsVisible && type === ReferralContext.Referrals"
    [rtTooltip]="
      (showStatus && application.referralStatus === ReferralStatus.Claimed
        ? 'rtr.reward.tooltip.success'
        : 'rtr.reward.tooltip.default'
      ) | translate
    "
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipMaxWidth]="320"
    class="reward"
  >
    <rt-icon
      [colorToken]="
        !showStatus || application.referralStatus !== ReferralStatus.Claimed
          ? 'colorIconDefault'
          : 'colorIconLowDefault'
      "
      name="reward"
      margin-right-small-x
    ></rt-icon>
    <span [class.text-bold]="showStatus && application.referralStatus === ReferralStatus.Claimed">{{
      application.referralReward.name
    }}</span>
  </div>
  <div
    *ngIf="showStatus && application.referralStatus && type === ReferralContext.Offer"
    [rtTooltip]="offerTooltipTranslations[application.referralStatus]"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipMaxWidth]="320"
    class="reward"
  >
    <span *ngIf="application.referralStatus === ReferralStatus.InReview">{{
      'rtr.referrals.in_progress' | translate
    }}</span>
    <span *ngIf="application.referralStatus === ReferralStatus.ProcessComplete">{{
      'rtr.referrals.completed' | translate
    }}</span>
    <span *ngIf="application.referralStatus === ReferralStatus.Claimed" text-bold>
      {{ 'rtr.referrals.statuses.successful_referral' | translate }}</span
    >
  </div>
</rt-box>
